<template>
  <div class="hg-footer">
    <p>Copyright &copy; 2019-{{ currentYear }}</p>
    <p>
      沪 ICP 备 2024098589 号
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040191"
        target="_blank"
        class="footer-link">京公网安备11010502040191号</a>
    </p>
    <p>上海两着科技有限公司</p>
  </div>
</template>
<script>
export default {
  computed: {
    currentYear () {
      return (new Date()).getFullYear()
    }
  }
}
</script>
<style lang="scss">
.hg-footer {
  margin-bottom: 100px;
  text-align: center;
  font-size: 14px;
  p {
    margin: 0;
    line-height: 14px;
    .footer-link {
      text-decoration: none;
      color: #333;
      &:active,
      &:hover,
      &:visited {
        color: #333;
      }
      &::before {
        display: inline-block;
        content: "";
        background-image: url(https://static.lehe.com/higo/feseTT/m/welcome/ghs.png);
        background-size: cover;
        height: 10px;
        width: 10px;
      }
    }
    & + p {
      margin-top: 11px;
    }
  }
}
</style>
